namespace TabAurous.OMS {
    export interface CategoryMasterRow {
        CategoryId?: number;
        CategoryCode?: string;
        CategoryName?: string;
        ItemTypeId?: number;
        Image?: string;
        IsDisabled?: boolean;
        IsSizeApplicable?: boolean;
    }

    export namespace CategoryMasterRow {
        export const idProperty = 'CategoryId';
        export const nameProperty = 'CategoryCode';
        export const localTextPrefix = 'OMS.CategoryMaster';
        export const lookupKey = 'OMS.CategoryMaster';

        export function getLookup(): Q.Lookup<CategoryMasterRow> {
            return Q.getLookup<CategoryMasterRow>('OMS.CategoryMaster');
        }
        export const deletePermission = 'Product:Category:Delete';
        export const insertPermission = 'Product:Category:Add';
        export const readPermission = '*';
        export const updatePermission = 'Product:Category:Edit';

        export declare const enum Fields {
            CategoryId = "CategoryId",
            CategoryCode = "CategoryCode",
            CategoryName = "CategoryName",
            ItemTypeId = "ItemTypeId",
            Image = "Image",
            IsDisabled = "IsDisabled",
            IsSizeApplicable = "IsSizeApplicable"
        }
    }
}
